import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var basicPath = 'M24.1055 5.41656C23.7833 4.80602 23.0271 4.5723 22.4166 4.89453C21.806 5.21676 21.5723 5.97292 21.8945 6.58346L40.8945 42.5835C41.2168 43.194 41.9729 43.4277 42.5835 43.1055C43.194 42.7833 43.4277 42.0271 43.1055 41.4166L24.1055 5.41656ZM6 4.75C6.69036 4.75 7.25 5.30964 7.25 6V42C7.25 42.6904 6.69036 43.25 6 43.25C5.30964 43.25 4.75 42.6904 4.75 42V6C4.75 5.30964 5.30964 4.75 6 4.75ZM15 4.75C15.6904 4.75 16.25 5.30964 16.25 6V42C16.25 42.6904 15.6904 43.25 15 43.25C14.3096 43.25 13.75 42.6904 13.75 42V6C13.75 5.30964 14.3096 4.75 15 4.75Z';
var filledPath = 'M24.5477 5.18328C24.0966 4.32852 23.0379 4.00131 22.1832 4.45243C21.3284 4.90356 21.0012 5.96218 21.4523 6.81694L40.4523 42.8169C40.9035 43.6717 41.9621 43.9989 42.8168 43.5478C43.6716 43.0967 43.9988 42.038 43.5477 41.1833L24.5477 5.18328ZM6 4.2501C5.0335 4.2501 4.25 5.0336 4.25 6.0001V42.0001C4.25 42.9666 5.0335 43.7501 6 43.7501C6.9665 43.7501 7.75 42.9666 7.75 42.0001V6.0001C7.75 5.0336 6.9665 4.2501 6 4.2501ZM15 4.2501C14.0335 4.2501 13.25 5.0336 13.25 6.0001V42.0001C13.25 42.9666 14.0335 43.7501 15 43.7501C15.9665 43.7501 16.75 42.9666 16.75 42.0001V6.0001C16.75 5.0336 15.9665 4.2501 15 4.2501Z';
var LibraryIcon = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var iconFill = _ref.iconFill,
      props = _objectWithoutProperties(_ref, ["iconFill"]);

  var path = basicPath;

  if (iconFill && iconFill === 'fill') {
    path = filledPath;
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: path
  }));
});
LibraryIcon.displayName = 'LibraryIcon';
LibraryIcon.defaultProps = {
  'aria-label': 'Library'
};
export default LibraryIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/LibraryIcon/index.js
// module id = 1880
// module chunks = 12